export default __webpack_public_path__ + "static/media/AvatarMaker.ebae4f7b.svg";